import { Radio, Row, Col } from 'antd';
import React, { Component } from 'react';
import { isCurrentCellChecked } from './helper';
import { ButtonElement } from '../../../../../../FormElements/ButtonElement';
import { getQuestionTranslation, getTextForTranslation } from '../../../../../../utils/newAttendSurveyUtils';
import { KEY_CONSTANTS } from '../../constants';
import ErrorBlock from '../ErrorBlock';
import { AsterikLabel } from '../../../../../../Components/AsterikLabel';
import parse from "html-react-parser";
import "./index.scss";
import ScrollBar from '../../../../../../Packages/ScrollBar';
class TableMatrix extends Component {


    renderTable = (question) => {
        let answer = this.props.currentQuestionSet && this.props.currentQuestionSet.answer ? JSON.parse(this.props.currentQuestionSet.answer) : []
        return (
     
            <div className={this.props.questionDetails.blockImage ? `${this.props.currentClassname}matrixsurvey-img` : `${this.props.currentClassname}matrixsurvey-table`}>


                            <table>

                                <tr className='metric-row'>

                                    <th></th>
                                    {question.options.map((item, index) => <th key={index}><div className='matrixsurvey-table__head' >{parse(getQuestionTranslation({ language: this.props.selectedLanguage, question: item, key: this.props.selectedLanguage, isCustomMatrix:true }))}</div></th>)}


                                </tr>

                    {question.matrixQuestions.map((row, index) => {
                                    return <tr key={row.id}>
                                        <th className='fixed'>{parse(getQuestionTranslation({ language: this.props.selectedLanguage, question: row, key: this.props.selectedLanguage, isCustomMatrix:true }))} </th>
                                        {question.options.map(item => <th align='center' className={`metrix-th ${item.value === "0" ? "metrix-last" : ""}`}>
                                            {/* <Radio onChange={(event) => {
                                this.props.handleChangeTableMatrix(
                                    { answeredRadio: { checked: event.target.checked, rowId: row.value, columnId: item.value, }, blockId: this.props.questionDetails.blockId })
                                }} checked={isCurrentCellChecked({ rowId: row.value, columnId: item.value }, answer)} /> */}
                                           <div className='metrix-new-th'>
                                            <label class="radio-button-container" >
                                                <input type="radio" checked={isCurrentCellChecked({ rowId: row.value, columnId: item.value }, answer)} name={row.value} onChange={(event) => {
                                                    this.props.handleChangeTableMatrix(
                                                        { answeredRadio: { checked: event.currentTarget.checked === "on", rowId: row.value, columnId: item.value, label: item.label, question: row.text, questionDimension: this.props.questionDetails.dimension, staticQuestionId: row.staticQuestionId }, blockId: this.props.questionDetails.blockId })
                                                }} />
                                                <span class="checkmark"></span>
                                            </label>
                                            </div>
                                        </th>)}
                                    </tr>
                                })}
                            </table>


                        </div>

        )
    }

    render() {
        return (
            <div>{this.props.questionDetails.questions.map((question) => {
                return (<>
                    <h3>{this.props.questionDetails.dimension === "" ? "..." : this.props.questionDetails.dimension}{this.props.questionDetails.isRequired && < AsterikLabel className="required-icon" />}</h3>
                    <h5> {this.props.questionDetails.description && parse(this.props.questionDetails.description)}</h5>
                    {this.renderTable(question)}
                </>)
            })}
                <div className='multioption-block__button'>
                    {/* <ButtonElement type={'primary'} className='multipleoption-btn' onClick={() => this.props.handleGoPrevAndNext(false, false)}>
                        {getTextForTranslation({
                            language: this.props.selectedLanguage,
                            defaultTexts: this.props.defaultTexts,
                            translatedTexts: this.props.translatedTexts,
                            key: KEY_CONSTANTS.CONTINUE_BUTTON
                        })}
                    </ButtonElement> */}
                </div>
                <ErrorBlock manageScroller={this.props.manageScroller}/>

            </div>
        );
    }
}

export default TableMatrix;
